import {CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared.module';
import { reportRoutingModule } from './report-routing.module';
// import { AllticketComponent } from './allticket/allticket.component';
// import { AssetstatusreportComponent } from './assetstatusreport/assetstatusreport.component';
// import { PmsProfileReportComponent } from './pms-profile-report/pms-profile-report.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { TicketdetailsComponent } from '../all-shared/ticketdetails/ticketdetails.component';



@NgModule({
  declarations: [
    // AllticketComponent,
    // AssetstatusreportComponent,
    // PmsProfileReportComponent
    TicketdetailsComponent
  ],
    
  imports: [
    CommonModule,SharedModule,reportRoutingModule,NgxPaginationModule
  ],
    entryComponents: [TicketdetailsComponent],      // imported for new design change //sowmiya
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class ReportModuleModule { }
